import React from 'react';

import {
  IconButton,
  LegacyBox,
  KeyboardArrowRightIcon,
  KeyboardArrowLeftIcon,
  styled,
  makeStyles,
} from '@gogame/components';
const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.paper,
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    left: 0,
    transform: 'translate(-50%, -50%)',
    boxShadow: theme.shadows[2],
    width: '32px',
    minWidth: '32px',
    height: '32px',
    minHeight: '32px',
    borderColor: theme.palette.divider,
  },
}));

const SlideArrow = ({ open, ...props }) => {
  const classes = useStyles();
  return (
    <IconButton
      {...props}
      className={classes.root}
      variant={'outlined'}
      icon={open ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
    />
  );
};

const AnnotationsContainer = styled(LegacyBox)`
  width: 470px;
  height: 284px;
  position: relative;
  flex: 1 0 auto;
  z-index: 0;
`;

export const SlideBlock = styled(({ children, open, onToggle, ...props }) => {
  return (
    <LegacyBox vertical={true} {...props}>
      <SlideArrow open={open} onClick={onToggle} />
      <AnnotationsContainer
        vertical={true}
        style={{ display: open ? 'flex' : 'none ' }}
      >
        {children}
      </AnnotationsContainer>
    </LegacyBox>
  );
})`
  position: relative;
`;
